import { useQuery } from '@tanstack/react-query'
import {
  loadFancyBookmakerCommission,
  type FancyBookmakerCommissionQuery,
} from '@/api/map/fancyBookmakerCommission'
import { keys } from '@/api/hooks/shared/keys'

export function useFancyBookmakerCommission(
  query: FancyBookmakerCommissionQuery,
  enabled = true,
) {
  return useQuery({
    queryKey: keys.fancyBookmakerCommission(query),
    queryFn: () => loadFancyBookmakerCommission(query),
    enabled: enabled && Boolean(query.memberId && query.from && query.to),
  })
}
